import { IMediaData } from 'app_types/media/media.types';
import React, { Component, CSSProperties } from 'react';

import { ModalMediaLayout } from './../index'

interface IModalMediaComponentProps {
  media: IMediaData
  open: boolean
  className?: string
  style?: CSSProperties
  showName?: boolean
  showDescription?: boolean
  hideCloseButton?: boolean
  onClose?: ()=>any
}

interface IModalMediaComponentState {}

class ModalMediaComponent extends Component<IModalMediaComponentProps, IModalMediaComponentState> {

  constructor(props: IModalMediaComponentProps){
    super(props)
  }

  render() {
      return (
          <ModalMediaLayout
            {...this.props}
          />
      );
  }
}

export default ModalMediaComponent;
